<span class="h-6 inline-flex items-center px-[9px] rounded-full text-[12px] font-medium" [class]="classes">{{ label }}</span>
